import { createGtag } from "vue-gtag";

// GA4 setup. Aktif hanya jika VUE_APP_GA_ID (format "G-XXXXXXXXXX") diisi,
// jadi di dev/local tanpa env ID tag tidak dimuat sama sekali.
// pageTracker.router = auto page_view tiap ganti route (SPA).
// config.send_page_view=false mematikan pageview otomatis awal dari gtag
// supaya tidak dobel dengan pageTracker. Pastikan "Enhanced measurement"
// > page views juga dimatikan di GA4 Data Stream (rekomendasi vue-gtag).
export default function setupAnalytics(app, router) {
    const tagId = process.env.VUE_APP_GA_ID;
    if (!tagId) return; // ponytail: no ID -> no-op, tidak ada script GA yang dimuat

    app.use(
        createGtag({
            tagId,
            pageTracker: { router },
            config: { send_page_view: false },
        })
    );
}
